// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.history-visible[data-v-f741ae24] {\n  overflow: visible !important;\n}\n", ""]);
// Exports
module.exports = exports;
